// eslint-disable-next-line @typescript-eslint/no-var-requires
const pdfjsLib = require('pdfjs-dist/build/pdf') as any;

pdfjsLib.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js`;

/**
 * Converts all pages of a PDF (given its URL) to blob URLs.
 * Returns an array of blob URL strings, one per page.
 * Callers are responsible for revoking the URLs via URL.revokeObjectURL() when done.
 */
export async function getPdfPagesAsImages(pdfUrl: string): Promise<string[]> {
    const pdf = await pdfjsLib.getDocument({
        url: pdfUrl,
        cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/cmaps/',
        cMapPacked: true,
    }).promise;

    const images: string[] = [];

    for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
        const page = await pdf.getPage(pageNum);
        const viewport = page.getViewport({ scale: 1.5 });

        const canvas = document.createElement('canvas');
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        const context = canvas.getContext('2d');

        await page.render({ canvasContext: context, viewport }).promise;

        const blobUrl = await new Promise<string>((resolve, reject) => {
            canvas.toBlob(
                (blob) => {
                    if (blob) resolve(URL.createObjectURL(blob));
                    else reject(new Error(`Failed to create blob for page ${pageNum}`));
                },
                'image/jpeg',
                0.85,
            );
        });

        images.push(blobUrl);
    }

    return images;
}

export function isPdfUrl(url: string): boolean {
    // Matches standard .pdf URLs and URLs like:
    // ...filename.pdf_timestamp.application/pdf
    return /\.pdf/i.test(url) || /application\/pdf$/i.test(url);
}
